export default "__VITE_ASSET__Df3wCOGz__"